const divForgotPassConfirm = {
text: 'Contraseña alterada con éxito'
};

export default divForgotPassConfirm;
